import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  return (
    <div className="App">
      <Navbar />
      <main className="page" data-testid="page-main">
        {children}
      </main>
      <Footer />
    </div>
  );
}
